export default __webpack_public_path__ + "static/media/backgroundtriangulos.a46dfcfc.png";